import { ssoApi } from "@sso/apis";
import { ApiPageResponse, Product, SoftwareSummary } from "@sso/types";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const productsApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.PRODUCTS] }).injectEndpoints({
  endpoints: builder => ({
    products: builder.query<Product[], void>({
      query: () => ({ url: `${Endpoints.PRODUCTS}` }),
      transformResponse: (response: { result: Product[] }) => response.result,
      providesTags: [CacheKeys.PRODUCTS],
    }),
    productSummaries: builder.query<ApiPageResponse<SoftwareSummary>, string>({
      query: query => ({ url: `${Endpoints.PRODUCTS}/GetSoftwareSummaries?${query}` }),
      providesTags: [CacheKeys.PRODUCTS],
    }),
  }),
});

export const { useProductsQuery, useProductSummariesQuery } = productsApi;
